<div class="card">

    <div class="col-12">
        <div class="flex justify-content-center">
            <h4> {{'FARMER_SHARE_CHALLAN'| translate}}</h4>
        </div>

        <div class="p-fluid p-formgrid grid" id="printableArea">
            <!-- bank copy -->
            <div class="field col-12 md:col-6 page-break-after" reflow="true">
                <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                <div class="consent-form border">
                    <div class="print border bold" style="margin-top: 1px; text-align: center">
                        <div class="flex justify-content-center">
                            <img src="assets/micada_logo.png" alt="footer sections" width="100" height="40"
                                class="mr-2">
                        </div>
                        <div class="mt-3 headings">
                            <strong>
                                {{'MICADA_HEADING'| translate}}
                            </strong>
                            <br>
                            <strong>{{'HARYANA'| translate}} </strong><br>
                            <strong>
                                {{'FINANCIAL_YEAR_2022'| translate}}
                            </strong>
                        </div>
                    </div>
                    <div class="flex justify-content-center mt-1 subheading">
                        <p>{{'CHALLAN_FOR_PAYMENT_OF_DUE_DATE'| translate}}</p>
                    </div>

                    <!-- personal details start -->
                    <ng-container>
                        <!-- <div class="flex justify-content-center mt-5">
                        <h5>Personal Details</h5>
                        </div> -->
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'MODE_OF_PAYMENT'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.PaymentMode }}</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'NAME_OF_APPLICANT'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.ApplicantName | uppercase }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'CHALLAN_DATE'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.ChallanDate | date:'medium' }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICATION_NUMBER'| translate}}</p>
                                    </td>

                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AppId }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BENEFICIARY_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BeneficiaryName }}</p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'PAYMENT_DETAILS'| translate}}</p>
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BENEFICIARY_ACCOUNT_NO'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BeneficiaryAccountNo }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BANK_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BankName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BRANCH_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BranchName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IFSC_CODE'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.IFSCCODE }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AmountToBeDeposted }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED_IN_WORDS'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AmountToBeDepostedInWords }}</p>
                                    </td>
                                </tr>
                            </table>
                            <div class="flex justify-content-between mb-5 mt-2 px-2">
                                <div class="bold note mt-4">{{'DEPOSIT_DATE'| translate}}</div>
                                <div class="bold note mt-4">{{'SIGN_OF_DEPOSITOR'| translate}}</div>
                            </div>
                            <div class="flex justify-content-end bold mt-5 pt-5 px-2 note">{{'BANK_RECEIVING_STAMP'| translate}}</div>

                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="border note mt-3">
                            <div class="flex justify-content-start mt-2 px-4"><b>{{'NOTE'| translate}}</b>{{'PLEASE_DONT_MAKE_A_COPY_OF_CHALLAN'| translate}} </div>
                            <div class="flex justify-content-start px-4">{{'YOU_CAN_PAY_AT_ANY_BRANCH'| translate}}
                            </div>
                            <div class="flex justify-content-start mb-2 px-4">{{'CHALLAN_PAYMENT_NOTE'| translate}}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div id="space_generator_for_print"></div>
            <!-- customer copy -->
            <div class="field col-12 md:col-6" reflow="true">
                <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                <div class="consent-form border">
                    <div class="print border bold" style="margin-top: 1px; text-align: center">
                        <div class="flex justify-content-center">
                            <img src="assets/micada_logo.png" alt="footer sections" width="100" height="40"
                                class="mr-2">
                        </div>
                        <div class="mt-3 headings">
                            <strong>
                                {{'MICADA_HEADING'| translate}}
                            </strong>
                            <br>
                            <strong>{{'HARYANA'| translate}}</strong><br>
                            <strong>
                                {{'FINANCIAL_YEAR_2022'| translate}}
                            </strong>
                        </div>
                    </div>
                    <div class="flex justify-content-center mt-1 subheading">
                        <p>{{'CHALLAN_PAYMENT_DUE_AMOUNT_CUSTOMER_COPY'| translate}}</p>
                    </div>

                    <!-- personal details start -->
                    <ng-container>
                        <!-- <div class="flex justify-content-center mt-5">
                        <h5>Personal Details</h5>
                        </div> -->
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'MODE_OF_PAYMENT'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.PaymentMode }}</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'NAME_OF_APPLICANT'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.ApplicantName | uppercase }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'CHALLAN_DATE'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.ChallanDate | date:'medium' }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICATION_NUMBER'| translate}}</p>
                                    </td>

                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AppId }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BENEFICIARY_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BeneficiaryName }}</p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'PAYMENT_DETAILS'| translate}}</p>
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BENEFICIARY_ACCOUNT_NO'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BeneficiaryAccountNo }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BANK_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BankName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'BRANCH_NAME'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.BranchName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IFSC_CODE'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.IFSCCODE }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AmountToBeDeposted }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED_IN_WORDS'| translate}}</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanPrintData?.AmountToBeDepostedInWords }}</p>
                                    </td>
                                </tr>
                            </table>
                            <div class="flex justify-content-between mb-5 mt-2 px-2">
                                <div class="bold note mt-4">{{'DEPOSIT_DATE'| translate}}</div>
                                <div class="bold note mt-4">{{'SIGN_OF_DEPOSITOR'| translate}}</div>
                            </div>
                            <div class="flex justify-content-end bold mt-5 pt-5 px-2 note">{{'BANK_RECEIVING_STAMP'| translate}}</div>

                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="border note mt-3">
                            <div class="flex justify-content-start mt-2 px-4"><b>{{'NOTE'| translate}}</b>{{'PLEASE_DONT_MAKE_A_COPY_OF_CHALLAN'| translate}}
                                </div>
                            <div class="flex justify-content-start px-4">{{'YOU_CAN_PAY_AT_ANY_BRANCH'| translate}}
                            </div>
                            <div class="flex justify-content-start mb-2 px-4">{{'CHALLAN_PAYMENT_NOTE'| translate}}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="flex justify-content-around mt-5">
            <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT'| translate}}" (click)="onPrint('printableArea')"></button>
        </div>
    </div>
</div>